<template>
  <button
    type="button"
    class="relative mb-3 flex shrink-0 flex-col items-start justify-end overflow-hidden rounded-md bg-gradient-to-t from-theme-primary/20 to-theme-primary/5 bg-cover bg-center font-medium"
    :style="{
      backgroundImage: category.image
        ? `url('${category.image.thumbnailUrl}')`
        : null,
    }"
    style="min-height: 6rem"
  >
    <span
      v-if="showName"
      class="z-10 mx-2 mb-2 mt-2 block rounded bg-theme-background px-2 py-1 text-left font-primary text-sm text-theme-text"
    >
      {{ localize(category.name) }}
    </span>
  </button>
</template>

<script setup lang="ts">
import { CategoryResource } from '@menu/Types/Resources/CategoryResource';

import { computed } from 'vue';
import { localize } from '@menu/Utils/i18n';
import getRestaurant from '@menu/Utils/getRestaurant';

const props = defineProps<{
  category: CategoryResource;
  focused: boolean;
}>();

const restaurant = getRestaurant();

const showName = computed(() => {
  if (!props.category.image) {
    return true;
  }

  if (restaurant.slug === 'mist') {
    return false;
  }

  return true;
});
</script>
